import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';

import { getSubscriptionPath } from '../../../../../routes/constants';
import messages from '../../../../onboard/steps/label-step/messages';

/**
 * @returns {JSX.Element}
 */
export const AddTaxIDButton = () => {
  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    navigate(getSubscriptionPath());
  }, [navigate]);

  return (
    <Button onClick={handleOnClick} theme='tertiary'>
      <FormattedMessage {...messages.addTaxIDButton} />
    </Button>
  );
};
